module.exports = __webpack_public_path__ + "static/media/Circle.e9ee90cc.png";